export const DEFAULT_PINNED_ICON_WIDTH = 20;
export const MIN_PINNED_COLUMN_WIDTH = 30;

export const DEFAULT_PINNED_LEFT_COLUMN_WIDTH = 40;
export const DEFAULT_PINNED_RIGHT_COLUMN_WIDTH = 160;
